
import React, { FC, useMemo, useRef, useState } from 'react';

import {
    Card,
    Line,
    Row,
    Spacer,
    Text
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    Button,
    TextView,
    IconButton
} from '@components/2-molecules';

import Edit from '@assets/icons/edit_w';

import {
  PageHeader,
} from '@components/2-molecules';
import Sandwich from '@assets/icons/sandwich';

import { ForwardedPageProps } from '@lib/constants';


/* type Props = {
    navigation?: any;
    data: any;
} */

// TODO: Deprecate the use of a distinct View component
//       but use a read-only input component

// @ts-ignore
const ContactView: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

    const { name, phone, email, dueDays, addressLine1, addressLine2 } = data;

    // Combine address lines, filtering out any empty or undefined parts.
    const address = [addressLine1, addressLine2].filter(Boolean).join('\n');
    
    const pendingInvoiceAmount = "$ 00.00"; // Please compute real value
    const nInvoices = 0;


    return (
        <AppTemplate>
            
            <PageHeader title={"CONTACT"}
                right={<IconButton icon={<Edit/>} color={"#FFF"} onPress={()=>{navigation.navigate('ContactCreate', {data: data})}} />}
            />
            <Spacer h={1} />
 
            <Card>
                <TextView label={"Name"} defaultValue={name} />
                <Line h={1} />

                <TextView label={"Phone"} defaultValue={phone} />
                <Line h={1} />

                <TextView label={"Email"} defaultValue={email} />
                <Line h={1} />

                <TextView
                    label={"Due days"}
                    defaultValue={dueDays}
                />
                <Line h={1} />

                <TextView label={"Address"} multiline defaultValue={address} height={45} />
            </Card>

            {/* <Card>
                <Row>
                    <TextView mini label={"Pending Amount"} defaultValue={pendingInvoiceAmount} />
                    <TextView mini label={"# of document"} defaultValue={"0"} />
                </Row>
                <Spacer h={1} />

                <Button bg={"transparent"} xsmall bold color={"#434BFF"}>VIEW DOCUEMNT(S)</Button>
            </Card> */}
            
            <Spacer h={2} />
        </AppTemplate>
    );
};


import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
export default withForwardedNavigationParams<ForwardedPageProps>()(ContactView);